import { format } from 'date-fns';
import ru from 'date-fns/locale/ru';
import type { Match, MatchStatus, Team } from 'modules/client/tournaments/domain/types';
import type { MatchEntityDto } from 'modules/client/tournaments/domain/types/dtos';
import { USER_DEFAULT_AVATAR } from 'shared/constants/links';

function matchMapper(matches: Pick<MatchEntityDto, 'date' | 'teamMatches' | 'location' | 'id' | 'round'>[], teams: Team[]): Match[] {
  return matches.map((match) => {
    const homeTeam = match.teamMatches?.find((team) => team.teamOrder === 1)!;
    const awayTeam = match.teamMatches?.find((team) => team.teamOrder === 2)!;

    const date = match.date ? format(new Date(match.date), 'd MMM, eee', { locale: ru }) : 'Дата неизвестна';
    const time = match.date ? format(new Date(match.date), 'HH:mm', { locale: ru }) : 'Время неизвестно';
    const now = Date.now();

    let status: MatchStatus = 'scheduled';
    if (match.date) {
      const diffMs = now - new Date(match.date).getTime();
      const diffHours = diffMs / (1000 * 60 * 60);

      switch (true) {
        case diffHours < 0:
          status = 'scheduled';
          break;
        case diffHours > 3:
          status = 'finished';
          break;
        default:
          status = 'live';
          break;
      }
    }

    return {
      id: match.id,
      date,
      time,
      homeTeam: teams.find((team) => team.id === homeTeam?.team?.id) ?? unknowTeam,
      awayTeam: teams.find((team) => team.id === awayTeam?.team?.id) ?? unknowTeam,
      homeScore: homeTeam.score,
      awayScore: awayTeam.score,
      status,
      stageId: match.round?.stage.id,
      venue: match.location?.name ?? 'Неизвестная локация',
      round: match.round?.name,
    };
  });
}

export default matchMapper;

const unknowTeam: Team = {
  id: -1,
  name: 'Команда неизвестна',
  shortName: 'UNK',
  logo: USER_DEFAULT_AVATAR,
  position: -1,
  form: [],
  played: 0,
  won: 0,
  goalDifference: 0,
  goalsAgainst: 0,
  lost: 0,
  goalsFor: 0,
  drawn: 0,
  points: 0,
};
